import React, { Component } from 'react'
import { FormControl, Popper, ClickAwayListener, TextField, InputAdornment } from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import { withTranslation } from 'react-i18next';
import BoundedPeriodGrid from '../../../PeriodPicker/BoundedPeriodGrid';
import { PERIOD_BOUNDS } from '../../../PeriodPicker/usePeriodBounds';
import { formatPeriod, parsePeriodFromDateString, periodFromDate } from '../../../../utils/DateUtils';

export class PeriodInput extends Component {
  constructor(props) {
    super(props);
    const currentPeriod = periodFromDate(new Date());
    // The stored value wins; `defaultMonth` only seeds a period that has none yet.
    const period = parsePeriodFromDateString(props.formState.mappedData[props.inputId])
      || { year: currentPeriod.year, month: props.defaultMonth || currentPeriod.month };

    this.state = {
      anchorEl: null,
      period,
      // Which year the grid is showing. View state only, reset on every open.
      browsedYear: null,
      loading: true,
        }
  }

  componentDidMount() {
    if (this.state.loading) {
      if (this.props.onChangeHandler) {
                this.props.onChangeHandler([this.props.inputId], formatPeriod(this.state.period))
      }

            this.setState({ loading: false })
    }
  }

    handleClick = (event) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget, browsedYear: null });
    }

  close = () => {
    this.setState({ anchorEl: null });
    }

  onSetDate = (year, month) => {
    const period = { year, month };

    if (this.props.onChangeHandler) {
            this.props.onChangeHandler([this.props.inputId], formatPeriod(period))
    }

    this.setState({ anchorEl: null, period });
    }

  render() {
    const { required, classes, label, id, formState, enterPressed, t } = this.props;
    const error = Boolean(formState.errors[id]);
    const inputLabel = required ? required(t(label)) : t(label);

    return (
      <FormControl className={classes.formControl} key={id} error={error}>
        <TextField
          label={inputLabel}
          value={formatPeriod(this.state.period)}
          onClick={this.handleClick}
                    style={{ width: 200, cursor: "pointer" }}
          error={error}
          className={classes.input}
          onKeyPress={enterPressed}
                    key={"input" + id}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                                <CalendarTodayIcon
                                    cursor="pointer"
                                    onClick={this.handleClick}
                                />
              </InputAdornment>
                        )
          }}
        />
                <Popper
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    placement="bottom-start"
                >
          <ClickAwayListener onClickAway={this.close}>
            <div>
              <BoundedPeriodGrid
                boundsSource={PERIOD_BOUNDS.PLANNING}
                year={this.state.browsedYear || this.state.period.year}
                onChangeYear={(year) => this.setState({ browsedYear: year })}
                onSelect={this.onSetDate}
                onClear={null}
              />
            </div>
          </ClickAwayListener>
        </Popper>
      </FormControl>
    );
  }
}

export default withTranslation('fieldLabels')(PeriodInput);
